import { createFileRoute } from '@tanstack/react-router';

import { DemandsPage as PartLibraryDemandsPage } from '@/areas/demand/Demand/DemandsPage/DemandsPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/_sidebar/demands/')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PartLibraryDemandsPage />;
}
